import React, { useContext, useEffect, useState } from 'react';
import { FormContext } from '../Form';
import Button from '../Button';
import Row from '../../layout/Row';
import Input from '../Input';
import WCImages from '../assetCollections/WCImages';
import styled from 'styled-components';
import { dec2Hex } from '../../utility/functions';

const Wrapper = styled.div`
    position: relative;
`

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 95%;
    background: ${({ color }) => color}cc;
`

const ImageIndex = ({ ...props }) => {
    const context = useContext(FormContext);
    const colorName = props.colorName || 'logoColor';
    const indexName = props.name || 'logoImageIndex';

    const [state, setState] = useState(context.values[indexName]);
    const [images] = useState(props.images || WCImages);
    const [hasColor, setHas] = useState(context.values[colorName] ? true : false);

    const updateState = (num) => {
        const index = (num + state + images.length) % images.length;
        setState(index);
        context.values[indexName] = index;
    }

    useEffect(() => {
        setState(context.values[indexName]);
        setHas(context.values[colorName] ? true : false);
    }, [context.initial])

    useEffect(() => {
        setHas(context.values[colorName] ? true : false);
    }, [context.values[colorName]])

    return (
        <>
            <Row>
                <b>Image</b>
                <Input
                    name={props.name || 'logoImageIndex'}
                    type='hidden'
                    {...props}
                />
            </Row>
            <Row>
                <Button onClick={() => updateState(-1)}>{'<'}</Button>
                {
                    state > 0 ?
                        <Wrapper>
                            {hasColor && <Overlay color={dec2Hex(context.values[colorName])} />}
                            <img src={images[state]} alt='imageIndex' />
                        </Wrapper>
                        : <b>No Image</b>
                }
                <Button onClick={() => updateState(1)}>{'>'}</Button>
            </Row>
        </>
    )
}

export default ImageIndex;
